import { render, staticRenderFns } from "./MixedOriginSamplesModal.vue?vue&type=template&id=53fe5820&scoped=true"
import script from "./MixedOriginSamplesModal.vue?vue&type=script&lang=js"
export * from "./MixedOriginSamplesModal.vue?vue&type=script&lang=js"
import style0 from "./MixedOriginSamplesModal.vue?vue&type=style&index=0&id=53fe5820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe5820",
  null
  
)

export default component.exports